type VAssetClassSourceBase = {
  sourceTypeName: string,
  sourceDate: Date,
  sourceInformation: string,
  sourceCredibility: string,
  validationSource: string,
  webAddress: string,
  picture_1: string
  picture_2: string
}

export type VAssetClassSource
  = VAssetClassSourceBase & {
    sourceType: 'Transacted',
    transactionDate: Date,
  }
  | VAssetClassSourceBase & {
    sourceType: 'Advertised',
    informationDate: Date
  }


export type VTargetPropertyConsideration
  = VTargetPropertyConsiderationSale
  | VTargetPropertyConsiderationRent

export type VTargetPropertyConsiderationSale = {
  considerationType: 'Sale'
  considerationTypeName: string
}

export type VTargetPropertyConsiderationRent = {
  considerationType: 'Rent'
  considerationTypeName: string
}

type VAssetClassConsiderationBase = {
  id: number,
  currency: string,
  tenureName: string,
  value: number,
  conversion: { id: number, quoteCurrency: string, exchangeRate: number }[]
  source: VAssetClassSource | null
}

export type VAssetClassConsideration
  = VAssetClassConsiderationSale
  | VAssetClassConsiderationRentEffective
  | VAssetClassConsiderationRentHeadline
  | VAssetClassConsiderationLand

export type VAssetClassConsiderationSale = VAssetClassConsiderationBase & {
  considerationType: 'Sale',
  oldTenure: any
}
export type VAssetClassConsiderationRentEffective = VAssetClassConsiderationBase & {
  considerationType: 'Rent',
  rentType: 'Effective',
  oldTenure: any
}

export type VAssetClassConsiderationRentHeadline = VAssetClassConsiderationBase & {
  considerationType: 'Rent'
  rentType: 'Headline',
  oldTenure: any
}

export type VAssetClassConsiderationLand = VAssetClassConsiderationBase & {
  considerationType: 'Land',
}

export function displayConsiderations(considerations: VAssetClassConsideration[]): VAssetClassConsideration[] {
  const items = [];
  const freeholds = considerations.filter(item => item.tenureName === 'Freehold')
  if (freeholds.length > 0) {
    items.push(freeholds[0])
  }
  const leaseholds = considerations.filter(item => item.tenureName === 'Leasehold')
  if (leaseholds.length > 0) {
    items.push(leaseholds[0])
  }
  return items
}